<template>
  <div class="success-phone">
    <i class="el-icon-circle-check"></i>
    <p class="txt">修改成功</p>
    <div class="btn go-back" @click="$router.push({ name: 'AccountSettings' })">
      返回
    </div>
  </div>
</template>

<script>
export default {
  name: 'successPhone',
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.success-phone {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 22px;
  .txt {
    color: #595959;
    margin: 20px 0 80px;
  }
  .btn {
    height: 50px;
    line-height: 50px;
    background-color: $--color-primary;
    border-radius: 4px;
    width: 200px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    &:hover {
      filter: brightness(105%);
    }
  }
}

.el-icon-circle-check {
  font-size: 150px;
  color: $--color-primary;
}
</style>
